<template>
  <BModal
    active
    has-modal-card
    @close="() => $router.push({ name: 'SecondaryUsers' })"
  >
    <form
      class="modal-card"
      @submit.prevent="create"
    >
      <header class="modal-card-head">
        <p class="modal-card-title has-text-primary">
          Nuevo usuario
        </p>
      </header>
      <section class="modal-card-body">
        <NewSecondaryUser :loading="loading" />
      </section>
      <footer class="modal-card-foot">
        <RouterLink
          class="button"
          :to="{ name: 'SecondaryUsers' }"
        >
          Cerrar
        </RouterLink>

        <button
          type="submit"
          class="button is-primary"
        >
          Crear usuario
        </Button>
      </footer>
    </form>
  </BModal>
</template>

<script>
export default {
  name: 'SecondaryUserPush',
  components: {
    NewSecondaryUser: () => import(/* webpackChunkName: "new-secondary-user" */ '@/components/Admin/SecondaryUser/NewSecondaryUser.vue'),
  },
  data() { return { loading: false }; },
  methods: {
    async create(event) {
      event.stopPropagation();

      this.loading = true;

      try {
        await this.$store.dispatch('users/createSecondary');

        this.$success({ message: 'Usuario creado exitosamente' });

        this.$router.push({ name: 'SecondaryUsers' });
      } catch (error) {
        this.$danger({ message: error.message });
      }

      this.loading = false;
    },
  },
};
</script>

<style scoped>
form {
  width: auto;
}
</style>
